
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec148"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec148"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7nhm9 = parcelRequire("7nhm9");
// VARIABLES
const $2823ea50e126c491$var$headerFontContainer = document.querySelector(".header__font-container");
const $2823ea50e126c491$var$headerFontStyles = document.querySelector(".header__font-styles");
const $2823ea50e126c491$var$headerFont = document.querySelector(".header__font");
const $2823ea50e126c491$var$bodyElement = document.body;
// EVENT LISTENER CALLBACK FUNCTIONS
function $2823ea50e126c491$var$handleHeaderFontContainerClick(e) {
    const headerFontContainer = e.target.closest(".header__font-container");
    if (!headerFontContainer) return;
    // If 'headerFontStyles' is currently being displayed, hide it.
    const isHeaderFontStylesDisplayed = !$2823ea50e126c491$var$headerFontStyles.classList.contains("hidden") && e.target.closest(".header__font-styles") !== $2823ea50e126c491$var$headerFontStyles;
    if (isHeaderFontStylesDisplayed) {
        (0, $7nhm9.hideElement)($2823ea50e126c491$var$headerFontStyles);
        return;
    }
    // Display headerFontStyles
    (0, $7nhm9.displayElement)($2823ea50e126c491$var$headerFontStyles);
}
function $2823ea50e126c491$var$handleHeaderFontStylesClick(e) {
    if (e.target.classList.contains("header__font-style")) {
        // Change the textContent of 'headerFont' to the font style that was clicked and hide 'headerFontStyles'.
        const fontStyle = e.target.textContent;
        $2823ea50e126c491$var$headerFont.textContent = fontStyle;
        (0, $7nhm9.hideElement)($2823ea50e126c491$var$headerFontStyles);
        // Remove all existing font classes
        (0, $7nhm9.removeClasses)($2823ea50e126c491$var$bodyElement, "body--font-inter", "body--font-lora", "body--font-inconsolata");
        // Change body element's 'font-family' value to the font style that was clicked
        (0, $7nhm9.changeFontFamily)(fontStyle, $2823ea50e126c491$var$bodyElement);
        // Stop the click event from propagating to the parent container
        e.stopPropagation();
    }
}
function $2823ea50e126c491$var$handleDocumentClick(e) {
    if (e.target.closest(".header__font-container") !== $2823ea50e126c491$var$headerFontContainer) (0, $7nhm9.hideElement)($2823ea50e126c491$var$headerFontStyles);
}
// EVENT LISTENERS
$2823ea50e126c491$var$headerFontContainer.addEventListener("click", $2823ea50e126c491$var$handleHeaderFontContainerClick);
$2823ea50e126c491$var$headerFontStyles.addEventListener("click", $2823ea50e126c491$var$handleHeaderFontStylesClick);
document.addEventListener("click", $2823ea50e126c491$var$handleDocumentClick);


//# sourceMappingURL=index.30a29d73.js.map
